export const tag_popular_list_jp = [
  '春夏',
  'デコラティブ',
  '壁紙',
  '包装紙',
  'ボタニカル',
  'アーティスティック',
  '手描き',
  '華やか',
  '秋冬',
  'モダン',
  '水彩',
  'モダン',

  'グラフィック',
  'ベクターパターン',
  'デジタル',
  'グラフィックパターン',
  'リーフ',
  'アブストラクトフラワー',
  '夏',
  'アート',
  'フラワー',
  'ビッグフラワー',
  'レイヤー',
  'ブロッサム',
  'ヴィンテージ',
  'ロマンチック',
  'マルチカラー',
  'イラスト',
  'グラフィックフラワー',
  'エキゾチック',
  '秋冬',
  'ブルー',
  'レトロ',

  'ワイルドフラワー',
  'ピンク',
  'シェイプ',
  '大胆',
  'リーフ',
  'ブラシストローク',
  'アウトライン',
  '植物',
  'ブライト',
  'プレイフル',
  'プリティ',
  'インテンス',
  'ジャングル',
  'リゾート',
  'ファン',
  'グリーン',
  '真夏',
  'オーナメンタル',
  'パステル',
  'フローリッシュ',
  'シンプル',
  '春',
  '無彩色',
  'ブラック',
  'モノクロ',
  'イエロー',
  'グリーン',
  'キュート',
  'レッド',
  'ローズ',
  'レオパード',
  'ドット',
  'ピープル',
  'デリケート',
  '小花柄',
  'ダーク',
  'サイケデリック',
  'パーム',
  'ガール',
  'ミニマル',
  'オレンジ',
  'ホワイト',
  'ライン',
  'ラージスケール',
  'ブラウン',
  'パープル',
  '秋',
  'ハワイアン',
  '青と白',
  'ドット',
  'ペイズリー',
  'スケッチ',
  'トーナル',
  'アフリカン',
  'タイダイ',
  'シンメトリー',

  'ブーケ',
  '落書き',
  'グレー',
  'シルエット',
  'フォークロア',
  '鳥',
  'ジグザグ',
  'オリエンタル',
  '秋',
  'モチーフ',
  'サークル',
  'ネイビー',
  'パッチワーク',
  'ウェーブ',
  'クリーム色',
  'グランジ',
  '森',
  '1970年代',
  'ゼブラ',
  'モダニズム',
  'モザイク',
  '冬',

  'スクエア',
  'タイガー',
  'インク',
  'オプティカル',

  '花びら',
  'フルーツ',
  'インディアン',
  'バティック',
  '1980年代',
  'コラージュ',
  'トライアングル',
  'コーラル',
  'ディストーテッド',
  'デイジー',
  'スモールスケール',
  'ブラー',
  'インディゴ',
  'マーブル',
  'ウォーター',
  'フューチャー',

  '藍色',
  '光',
  'スミレ',
  'ナイーブ',
  'ミクストメディア',
  'カレイドスコープ',
  'ライラック',
  'ターコイズ',
  '牡丹',

  'ゴールド',
  '和風',
  '牧草地',
  'バンダナ',

  'スワール',
  'イカット',
  '蝶',
  '1990年代',
  'フォトグラフィック',
  'バケーション',
  'ネオン',
  'ストリートアート',
  '1960年代',
  'ダークグリーン',
  'オーシャン',
  '印象派',
  'スクリブル',
  'スカーフ',
  'マゼンタ',
  'ユリ',
  'ダイヤモンド',
  'ティール',
  '北欧風',
  'モロッカン',
  'スター',
  'ローズ',
  '木',
  'ハイビスカス',
  '蘭',
  'グラフィティ',
  'ミラー',
  'バロック',
  '刺繍',
  'コミック',
  'スネーク',
  'アズテック',

  '建築',
  'レース',
  'アールヌーボー',
  'オンブレ',
  'ポピー',

  '織り',
  'ティール',
  'ノーティカル',
  '宇宙',
  '風景',
  '絞り染め',
  'ギャラクシー',
  'シェブロン',
  'マンダラ',
  '着物',
  'シノワズリ',
  'ホットピンク',
  'フーラード',
  'フード',
  'クリスマス',
  '魚',
  'ハート',
  'レインボー',
  'スペーシング',
  '昆虫',
  'チューリップ',
  'ステンシル',
  'フェード',
  'シダ',
  '猫',
  'レモン',
  '羽',
  '1940年代',
  'ジャカード',
  'メキシカン',
  'タータン',
  'バウハウス',

  'ピクセル',

  'チェーン',
  'バナナ',
  'ラベンダー',
  '雲',
  'モクレン',
  '3D',
  '1950年代',
  'パンク',
  'サボテン',
  'ジュエリー',
  'オウム',
  'キリン',
  '野菜',
  'キャンディ',
  'ピープル',
  'フラミンゴ',
  'パイナップル',
  'ハウンドトゥース',

  'ゴシック',
  'イチゴ',
  'ニット',

  'アヤメ',
  '馬',
  'チェリー',
  'ギンガムチェック',
  'バレンタイン',
  'レター',
  'お菓子',
  '竹',
  'シルバー',
  'ハロウィン',
  '夏祭り',
  '犬',
  'パンジー',
  'リンゴ',
  '蛾',
  'ヒトデ',
  '水仙',

  'ヘリンボーン',
  'ビートル',
  '象',
  'ウサギ',
  'ボート',
  'アイスクリーム',
  'スカル',
  'クジラ',
  'ドリンク',

  '車',
  'イルカ',
  'カエル',
  '数字',
];
